import React, { useState } from "react";
import { Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { apiGetFillQuality } from "api/apiBrokerOrders";
import FillQualityTable from "./FillQualityTable";

// Strategy page: how well AutoTrader's orders for this strategy were filled
const FillQualityCard = ({ strategyId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      setData(await apiGetFillQuality(strategyId));
    } catch (error) {
      console.error("Error fetching fill quality:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <GenericCard
      title="Fill Quality"
      className="table-card"
      isCardOpenByDefault={false}
      onCardOpen={load}
      tooltipText="AutoTrader fills of this strategy vs the mid at placement and vs the strategy's price, by algo and urgency"
    >
      <div className="flex justify-end mb-4">
        <Button type="primary" icon={<ReloadOutlined />} onClick={load} loading={loading}>
          Refresh Data
        </Button>
      </div>
      {data && !data.total?.orders ? (
        <div>No filled AutoTrader orders yet.</div>
      ) : (
        <FillQualityTable data={data} />
      )}
    </GenericCard>
  );
};

export default FillQualityCard;
